var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSiGlyphCustomerSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1239 15.1164C9.34258 15.1164 7.53288 14.0464 6.4767 12.6302C1.40952 12.6302 1.25635 19.9552 1.25635 19.9552H20.9902C20.9902 19.9552 21.3879 12.5977 15.6895 12.5977C14.6346 14.0314 12.9052 15.1164 11.1239 15.1164Z",
    fill: "#0066A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3684 6.33578C15.3684 8.44328 13.4673 12.4733 11.1202 12.4733C8.77686 12.4733 6.87451 8.44203 6.87451 6.33578C6.87451 4.22953 8.77563 2.51953 11.1202 2.51953C13.4673 2.52078 15.3684 4.23078 15.3684 6.33578Z",
    fill: "#0066A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2635 4.51734C17.2635 4.12234 16.7199 3.80359 16.0455 3.80109V2.98734C16.0455 2.86609 16.0912 0.0273438 11.1352 0.0273438C6.18163 0.0273438 6.22734 2.86609 6.22734 2.98734V3.82984C6.21499 3.82984 6.2051 3.82609 6.19399 3.82609C5.52322 3.82609 4.9834 4.13984 4.9834 4.52859V7.97109C4.9834 8.35734 5.52446 8.67234 6.19399 8.67234C6.86352 8.67234 7.40705 8.35734 7.40705 7.97109V4.52859C7.40705 4.47484 7.37369 4.42609 7.35393 4.37609V3.43734C7.35393 3.35109 6.99816 1.20859 11.1352 1.20859C15.2734 1.20859 14.8435 3.35109 14.8435 3.43734V4.42609C14.8361 4.45734 14.8126 4.48484 14.8126 4.51734V8.03859C14.8126 8.43484 15.3599 8.75609 16.038 8.75609C16.0529 8.75609 16.064 8.75109 16.0788 8.75109V10.0373H14.8633V11.2498H17.2758L17.2635 4.51734Z",
    fill: "#0066A4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiGlyphCustomerSupport);
export default __webpack_public_path__ + "static/media/si-glyph-customer-support.d8dd9481.svg";
export { ForwardRef as ReactComponent };